import { selectBuildById } from '../reducers/savedBuild';
import { useApiHost, useLanguage } from '../../utils/sitecoreContext';
import { useAppSelector } from '../utils';
import { useGetSavedBuildQuery } from '../apis/hondaRestApi';
const useBapGetBuildById = (buildId, accessToken) => {
    const language = useLanguage();
    const hondaRestApiHost = useApiHost();
    const savedBuildData = useAppSelector(state => selectBuildById(state, buildId));
    const buildsApiUrl = `https://${hondaRestApiHost}/builds/${buildId}?AcceptLanguage=${language}`;
    useGetSavedBuildQuery({
        url: buildsApiUrl,
        headers: { Authorization: `${accessToken === null || accessToken === void 0 ? void 0 : accessToken.tokenType} ${accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken}` },
        buildId: buildId || '',
    }, { skip: !buildId || !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken) });
    return { buildData: savedBuildData, isError: (savedBuildData === null || savedBuildData === void 0 ? void 0 : savedBuildData.isError) || false };
};
export default useBapGetBuildById;
